import React from 'react'
import * as PropTypes from 'prop-types'
import {ButtonPrimary, HelpIcon, Tooltip, SkeletonButton} from '@modifi/ui'
import {InferPropTypes} from '@modifi/typescript-utils'
import {useTranslation} from '@modifi/plugin-i18n'
import {darkGray} from '@modifi/colors'
import {TooltipIconWrapper, Wrapper} from './styles'

const InfoIcon = React.forwardRef((props, ref) => (
  // @ts-expect-error
  <TooltipIconWrapper ref={ref}>
    <HelpIcon color={darkGray} width={24} height={24} {...props} />
  </TooltipIconWrapper>
))

const propTypes = {
  documentType: PropTypes.string.isRequired,
  // onPartnerFileSelection: PropTypes.func.isRequired,
  // multiple: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
}
const defaultProps = {
  // multiple: false,
  isDisabled: false,
  className: undefined,
}

type DocumentTypeActionsColProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const DocumentTypeActionsCol: React.FC<DocumentTypeActionsColProps> = ({
  documentType,
  // onPartnerFileSelection,
  // multiple,
  isDisabled,
  className,
}) => {
  const {t, ready: tReady} = useTranslation('argus', {useSuspense: false})

  return (
    <Wrapper auto pt={4} className={className}>
      {tReady ? (
        <ButtonPrimary
          type="button"
          data-target="upload-document"
          data-document-type={documentType}
          active={!isDisabled}
          inverse
        >
          {t('submit-shipment-form.upload.cta')}
        </ButtonPrimary>
      ) : (
        <SkeletonButton>
          <ButtonPrimary
            type="button"
            data-target="upload-document"
            data-document-type={documentType}
            active={!isDisabled}
            inverse
          >
            Upload
          </ButtonPrimary>
        </SkeletonButton>
      )}
      <Tooltip refComponent={InfoIcon}>{t('upload-document.tooltip')}</Tooltip>
    </Wrapper>
  )
}

DocumentTypeActionsCol.propTypes = propTypes
DocumentTypeActionsCol.defaultProps = defaultProps

export default DocumentTypeActionsCol
